// @noflow
// eslint-disable-next-line flowtype/newline-after-flow-annotation
import { isDevelopment } from '@/utils/isDevelopment'

import initPaw from '@/components/paw'

document.addEventListener('DOMContentLoaded', (): void => {
  if (isDevelopment()) {
    initPaw()
  }
})
